export const EMAIL_CHANGE_BROWSER_RESTART_KIND = 'email_change_browser_restart';

export const TERMINAL_ERROR_STATUSES = new Set([
  'failed',
  'terminal_failed',
  'operator_review',
  'cancelled',
]);

export function isTerminalErrorStatus(status) {
  return TERMINAL_ERROR_STATUSES.has(status);
}

export function isEmailChangeBrowserRestartState(state) {
  if (!state || typeof state !== 'object') return false;
  return state.status === 'failed'
    && state.can_rejoin === true
    && state.last_recoverable_failure_kind === EMAIL_CHANGE_BROWSER_RESTART_KIND;
}

// RESET-CODE-INBOX-NUDGE (2026-10-09, thread reset-code-wizard-nudge): the
// "watch your inbox for a reset code" nudge belongs ONLY to the recovering
// screen shown BEFORE the code arrives. The BE projects recovering_password
// AGAIN for the rest of a reset: v3_driver clears awaiting_2fa in a finally the
// moment the code relay returns, while password_reset_flow stays true until
// run_v3_loop finishes (code submit -> set-new-password -> feed). So without
// this latch a seller who just typed the code is told "a code is coming, enter
// it here in a moment" — stale and confusing. Once the code-entry prompt
// (waiting_for_code) has been shown this session, the nudge is suppressed and
// the recovering screen reverts to its neutral passive line.
export function shouldShowResetInboxNudge(flagEnabled, resetCodePromptSeen) {
  return !!flagEnabled && !resetCodePromptSeen;
}

// The reset code-entry surfaces. A reset code of kind needs_email_code / needs_code
// projects as waiting_for_code; a needs_otp reset code projects as waiting_for_2fa
// (session_state.derive_challenge_projection, password_reset_flow branch). The
// latch must set on EITHER, or the OTP reset path re-shows the stale nudge after
// the code (verifier 020f6d3c, verification 2).
export const RESET_CODE_ENTRY_STATUSES = new Set(['waiting_for_code', 'waiting_for_2fa']);
export function isResetCodeEntryStatus(status) {
  return RESET_CODE_ENTRY_STATUSES.has(status);
}

// Persist the "code prompt was shown" latch per session id, so a reload during
// the post-code recovering_password phase does not re-show the nudge (React
// state alone is lost on reload — verifier 020f6d3c, verification 2). session
// storage is per-tab and cleared when the tab closes, which matches the
// per-takeover-session scope. Every access is guarded: a private window or
// blocked storage throws, and the nudge must still render correctly.
export function resetNudgeSeenKey(sessionId) {
  return sessionId ? `takeover.resetCodePromptSeen.${sessionId}` : null;
}
export function readResetCodePromptSeen(sessionId) {
  try {
    const k = resetNudgeSeenKey(sessionId);
    if (!k || typeof window === 'undefined' || !window.sessionStorage) return false;
    return window.sessionStorage.getItem(k) === '1';
  } catch (e) {
    return false;
  }
}
export function persistResetCodePromptSeen(sessionId) {
  try {
    const k = resetNudgeSeenKey(sessionId);
    if (k && typeof window !== 'undefined' && window.sessionStorage) {
      window.sessionStorage.setItem(k, '1');
    }
  } catch (e) {
    /* storage unavailable — the in-memory latch still covers the live session */
  }
}
